export default __webpack_public_path__ + "static/media/theme-l.0a4a553a.svg";